const exploreStyles = {
    container: `fixed bottom-[50px] right-[10px] bg-[#020529b3] rounded-full h-[100px] w-[100px] flex items-center justify-center z-[100] cursor-pointer`,
    explore_token: `absolute top-[6px]`,
    golden_box: `absolute bottom-[2px] w-[68px] h-[68px] animate-bounce`,
}



export { exploreStyles }